import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, NavigationSkipped, Router } from '@angular/router';
import { filter } from 'rxjs';
import { MenuItem } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import { environment } from '@environments/environment';
import { BreadcrumbModule } from 'primeng/breadcrumb';

@Component({
    selector: 'app-breadcrumbs',
    template: ` <p-breadcrumb
        [home]="home"
        [model]="menuItems"
        [class.empty]="menuItems.length === 0"
        [homeAriaLabel]="'Home'"></p-breadcrumb>`,
    styles: [
        `
            ::ng-deep .empty {
                display: none;
            }
        `,
    ],
    standalone: true,
    imports: [BreadcrumbModule],
})
export class BreadcrumbsComponent implements OnInit {
    static readonly ROUTE_DATA_BREADCRUMB = 'breadcrumb';
    home = { icon: 'pi pi-home', url: environment.quickorderUrl, label: '' };
    menuItems: MenuItem[] = [];

    constructor(
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private translate: TranslateService
    ) {}

    ngOnInit(): void {
        this.router.events
            .pipe(filter(event => event instanceof NavigationEnd || event instanceof NavigationSkipped))
            .subscribe(() => (this.menuItems = this.createBreadcrumbs(this.activatedRoute.root)));
    }

    private createBreadcrumbs(route: ActivatedRoute, url: string = '', breadcrumbs: MenuItem[] = []): MenuItem[] {
        const children: ActivatedRoute[] = route.children;

        if (children.length === 0) {
            if (route.snapshot.queryParams['type'] === 'retest') {
                breadcrumbs.push({ label: 'Retest', target: '_self' });
            } else if (route.snapshot.queryParams['type'] === 'investigation') {
                breadcrumbs.push({ label: 'Investigation', target: '_self' });
            }

            return breadcrumbs;
        }

        children.forEach(child => {
            const routeURL: string = child.snapshot.url.map(segment => segment.path).join('/');

            if (routeURL === 'checkmate') {
                breadcrumbs.push({ label: 'Orders', url: environment.ordersUrl, target: '_self' });
                breadcrumbs.push({ label: 'Order Results', url: environment.quickorderResultsUrl, target: '_self' });
            }

            if (routeURL !== '') {
                url += `/${routeURL}`;
            }

            const label = child.snapshot.data[BreadcrumbsComponent.ROUTE_DATA_BREADCRUMB];

            if (label !== null && label !== undefined) {
                breadcrumbs.push({ label: this.translate.instant(label), url, target: '_self', routerLink: [url] });
            }

            return this.createBreadcrumbs(child, url, breadcrumbs);
        });

        return breadcrumbs;
    }
}
